// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-container {
  padding-bottom: 80px;
}
@media screen and (min-width: 768px) {
  .preview-container {
    padding-bottom: 200px;
  }
}
.preview-container .preview-card-header {
  padding: 80px 20px;
  width: 100%;
}
@media screen and (min-width: 768px) {
  .preview-container .preview-card-header {
    padding: 140px 20px 150px;
  }
}
.preview-container .preview-card-header .summary-header {
  display: flex;
  flex-direction: row;
  padding: 10px;
}
.preview-container .preview-card-header .summary-header .summary-label {
  width: 10%;
}
.preview-container .preview-card-header .summary-header .summary-value {
  width: 10%;
}
.preview-container .preview-card-header .counter-container {
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  padding: 35px 0 49px;
}
@media screen and (min-width: 768px) {
  .preview-container .preview-card-header .counter-container {
    padding: 96px 0 78px;
  }
}
.preview-container .preview-card-header .counter-container .counter-items {
  max-width: 900px;
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  list-style: none;
}
.preview-container .preview-card-header .counter-container .counter-items .counter-item {
  width: 100%;
  text-align: center;
}
.preview-container .preview-card-header .counter-container .counter-items .counter-item h1 {
  font-size: 40px;
  line-height: 45px;
}
.preview-container .preview-card-header .counter-container .counter-items .counter-item p {
  font-size: 16px;
  line-height: 25px;
}
.preview-container .preview-card-header .counter-container .counter-items .counter-item {
  padding: 20px 0;
}
@media screen and (min-width: 768px) {
  .preview-container .preview-card-header .counter-container .counter-items .counter-item {
    width: 33.33%;
  }
}
.preview-container .preview-card-header .preview-button-container {
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
}
.preview-container .preview-card-header .preview-button-container .preview-header-action {
  max-width: 900px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.preview-container .preview-card-header .preview-button-container .preview-header-action button {
  width: 100%;
  margin-bottom: 15px;
}
@media screen and (min-width: 768px) {
  .preview-container .preview-card-header .preview-button-container .preview-header-action button {
    width: 49%;
    margin: 0 0 0 0;
  }
  .preview-container .preview-card-header .preview-button-container .preview-header-action button:first-child {
    width: calc(50% - 15px);
    margin-right: 15px;
  }
}
.preview-container .seperator {
  border: none;
  border-bottom: 0.5px solid #BFBFBF;
  width: 100%;
  margin: 0 20px 0;
}
@media screen and (min-width: 768px) {
  .preview-container .seperator {
    margin: 0 26px 0;
  }
}
.preview-container .validation-result {
  margin-top: 80px;
  width: 100%;
}
@media screen and (min-width: 768px) {
  .preview-container .validation-result {
    margin-top: 145px;
  }
}
.preview-container .validation-result h3 {
  text-align: center;
  margin-bottom: 70px;
}
.preview-container .validation-result {
  padding: 0 20px;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/bulk-card-issue/bulk-card-validation-preview/BulkCardValidationPreview.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;AAAE;EAFF;IAGI,qBAAA;EAGF;AACF;AAFE;EACE,kBAAA;EACA,WAAA;AAIJ;AAHI;EAHF;IAII,yBAAA;EAMJ;AACF;AALI;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AAON;AANM;EACE,UAAA;AAQR;AALI;EACI,UAAA;AAOR;AAHI;EACE,uBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;AAKN;AAHM;EANF;IAOI,oBAAA;EAMN;AACF;AALM;EACI,gBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAOV;AANU;EACI,WAAA;EACA,kBAAA;AAQd;AAPc;EACI,eAAA;EACA,iBAAA;AASlB;AAPc;EACI,eAAA;EACA,iBAAA;AASlB;AAlBU;EAWI,eAAA;AAUd;AATc;EAZJ;IAaQ,aAAA;EAYhB;AACF;AALI;EACE,uBAAA;EACA,aAAA;EACA,eAAA;AAON;AANM;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;AAQR;AAPQ;EACE,WAAA;EACA,mBAAA;AASV;AARU;EAHF;IAII,UAAA;IACA,eAAA;EAWV;EAVU;IACE,uBAAA;IACA,kBAAA;EAYZ;AACF;AANE;EACE,YAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;AAQJ;AAPI;EALF;IAMI,gBAAA;EAUJ;AACF;AARE;EACE,gBAAA;EACA,WAAA;AAUJ;AATI;EAHF;IAII,iBAAA;EAYJ;AACF;AAXI;EACE,kBAAA;EACA,mBAAA;AAaN;AArBE;EAUE,eAAA;EACA,eAAA;AAcJ","sourcesContent":[".preview-container {\n  padding-bottom: 80px;\n  @media screen and (min-width: 768px) {\n    padding-bottom: 200px;\n  }\n  & .preview-card-header {\n    padding: 80px 20px;\n    width: 100%;\n    @media screen and (min-width: 768px) {\n      padding: 140px 20px 150px;\n    }\n    & .summary-header {\n      display: flex;\n      flex-direction: row;\n      padding: 10px;\n      & .summary-label {\n        width: 10%;\n      }\n\n    & .summary-value {\n        width: 10%;\n      }\n\n    }\n    .counter-container{\n      justify-content: center;\n      display: flex;\n      flex-wrap: wrap;\n      padding: 35px 0 49px;\n      // border-bottom: 0.5px solid #BFBFBF;\n      @media screen and (min-width: 768px) {\n        padding: 96px 0 78px;\n      }\n      .counter-items{\n          max-width: 900px;\n          width: 100%;\n          margin: 0;\n          padding: 0;\n          display: flex;\n          flex-wrap: wrap;\n          justify-content: center;\n          align-items: center;\n          list-style: none;\n          .counter-item{\n              width: 100%;\n              text-align: center;\n              h1{\n                  font-size: 40px;\n                  line-height: 45px;\n              }\n              p{\n                  font-size: 16px;\n                  line-height: 25px;\n              }\n              padding: 20px 0;\n              @media screen and (min-width: 768px) {\n                  width: 33.33%;\n              }\n              // @media screen and (min-width: 1024px) {\n              //     width: 25%;\n              // }\n          }\n      }\n    }\n    .preview-button-container{\n      justify-content: center;\n      display: flex;\n      flex-wrap: wrap;\n      .preview-header-action{\n        max-width: 900px;\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        button{\n          width: 100%;\n          margin-bottom: 15px;\n          @media screen and (min-width: 768px) {\n            width: 49%;\n            margin: 0 0 0 0;\n            &:first-child{\n              width: calc( 50% - 15px );\n              margin-right: 15px;\n            }\n          }\n        }\n      }\n    }\n  }\n  .seperator{\n    border: none;\n    border-bottom: 0.5px solid #BFBFBF;\n    width: 100%;\n    margin: 0 20px 0;\n    @media screen and (min-width: 768px) {\n      margin: 0 26px 0;\n    }\n  }\n  .validation-result{\n    margin-top: 80px;\n    width: 100%;\n    @media screen and (min-width: 768px) {\n      margin-top: 145px;\n    }\n    h3{\n      text-align: center;\n      margin-bottom: 70px;\n    }\n    padding: 0 20px;\n    max-width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
